import { createSlice } from '@reduxjs/toolkit';
import { ReportPageState } from '../data/interfaces/reportmodels';



// Define the initial state using that type
const initialState:ReportPageState = {
    selectedNlcs: [],
    selectedTocs:[]
}
export const reportsSlice = createSlice({
    name: 'reports',
    initialState,
    reducers: {
        reset: () => initialState,
        updateselectedNlcs: (state, action) => {
            state.selectedNlcs = action.payload;
        },
        updateSelectedTocs:(state,action)=>{
            state.selectedTocs=action.payload;
        }
    },
});

export const { updateselectedNlcs,updateSelectedTocs } = reportsSlice.actions

export default reportsSlice.reducer